import { render, staticRenderFns } from "./ViewMainGroups.vue?vue&type=template&id=5a21d176"
import script from "./ViewMainGroups.vue?vue&type=script&lang=js"
export * from "./ViewMainGroups.vue?vue&type=script&lang=js"
import style0 from "./ViewMainGroups.vue?vue&type=style&index=0&id=5a21d176&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports